import { defineMessages } from 'react-intl';


export default defineMessages({
  instructionHeaderTitle: {
    id: 'app.containers.Photo.InstructionsHeaders.Title',
    defaultMessage: 'Envio de fotos',
  },
  instructionHeaderCardTitle: {
    id: 'app.containers.Photo.InstructionsHeaders.CardTitle',
    defaultMessage: 'Requisitos para enviar suas fotos',
  },
  instructionHeaderCardDescription: {
    id: 'app.containers.Photo.InstructionsHeaders.CardDescription',
    defaultMessage: 'Radio ',
  },
  instructionHeaderCardDescriptionItems: {
    id: 'app.containers.Photo.InstructionsHeaders.CardDescriptionItems',
    defaultMessage: '3:2',
  },
  secondInstructionHeaderCardDescription: {
    id: 'app.containers.Photo.InstructionsHeaders.SecondCardDescription',
    defaultMessage: 'Largura mínima ',
  },
  secondInstructionHeaderCardDescriptionBoldItem: {
    id: 'app.containers.Photo.InstructionsHeaders.SecondCardDescriptionItem',
    defaultMessage: '1152px',
  },
  thirdInstructionHeaderCardDescription: {
    id: 'app.containers.Photo.InstructionsHeaders.ThirdCardDescription',
    defaultMessage: 'As imagens devem ser no formato',
  },
  thirdInstructionHeaderCardDescriptionBoldItem: {
    id: 'app.containers.Photo.InstructionsHeaders.ThirdCardDescriptionItems',
    defaultMessage: 'JPG',
  },
  fourthInstructionHeaderCardDescription: {
    id: 'app.containers.Photo.InstructionsHeaders.FourthCardDescription',
    defaultMessage: 'Envie as fotos na ordem do checklist: ',
  },
  fourthInstructionHeaderCardDescriptionBoldItem: {
    id: 'app.containers.Photo.InstructionsHeaders.FourthCardDescriptionItems',
    defaultMessage: 'Sala / Quartos e suítes / Banheiros e lavabos / Cozinha / '
    + 'Área de serviço / Quarto e banheiro de serviço / Área comum / Fachada',
  },
  fifthInstructionHeaderCardDescription: {
    id: 'app.containers.Photo.InstructionsHeaders.FifthCardDescription',
    defaultMessage: 'Não se esqueça de selecionar',
  },
  fifthInstructionHeaderCardDescriptionBold: {
    id: 'app.containers.Photo.InstructionsHeaders.FifthCardDescriptionBold',
    defaultMessage: 'uma foto de capa para o anúncio',
  },
  successUpdatePhotos: {
    id: 'app.containers.Photo.UpdateRequest.Success',
    defaultMessage: 'Fotos salvas com sucesso!',
  },
  failureUpdatePhotos: {
    id: 'app.containers.Photo.UpdateRequest.Failure',
    defaultMessage: 'Erro ao salvar as fotos!',
  },
});
